import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import LiveLayout from "../components/livelayout"
import SEO from "../components/seo"

import "../style/main.scss"

import SNGabout from "../components/sngabout"
import SNGlisting from "../components/listing"
import About from "../components/about"
import Speakers from "../components/speakers"
import Agenda from "../components/agenda"
import Joinus from "../components/joinus"
import Location from "../components/location"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo,
              url
              width
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <LiveLayout>
      <SEO title="SNG Live" />
      <SNGabout />
      <SNGlisting />
      
      {/*<Location address={{}} displayMap={true} />*/}
    </LiveLayout>
  )
}

export default IndexPage